import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { BRAND } from '../config';

const G = '#00C060';
const G_DARK = '#006633';
const BG = '#f0f7f2';
const CARD = '#ffffff';
const BORDER = 'rgba(0, 192, 96, 0.4)';
const SHADOW = '0 2px 12px rgba(0,0,0,0.08)';
const selectStyle = { background: '#f8faf8', borderColor: 'rgba(0,166,81,0.35)', color: '#1a3322', width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid rgba(0,192,96,0.4)', fontSize: '15px' };

const Injection = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [prizes, setPrizes] = useState([]);
  const [selectedSession, setSelectedSession] = useState('');
  const [selectedPrize, setSelectedPrize] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    if (user?.role !== 'admin' && user?.role !== 'super_admin') { navigate('/dashboard'); return; }
    api.get('/admin/sessions', { params: { brand: BRAND } }).then(r => setSessions(r.data)).catch(() => {});
    api.get('/admin/prizes', { params: { brand: BRAND } }).then(r => setPrizes(r.data)).catch(() => {});
  }, [user, navigate]);

  const handleInject = async () => {
    if (!selectedSession || !selectedPrize) {
      setMessage({ type: 'danger', text: 'Veuillez sélectionner une session et un lot' });
      return;
    }
    setLoading(true);
    try {
      await api.post('/admin/inject-win', { session_id: parseInt(selectedSession), prize_type: selectedPrize, brand: BRAND });
      setMessage({ type: 'success', text: 'Gain injecté avec succès ! Le prochain joueur va gagner ce lot.' });
      setSelectedSession('');
      setSelectedPrize('');
    } catch (error) {
      setMessage({ type: 'danger', text: error.response?.data?.detail || "Erreur lors de l'injection" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100" style={{ background: BG }}>
      <nav className="navbar navbar-dark sticky-top" style={{ background: '#0a1f0c', padding: '10px 0', borderBottom: `2px solid rgba(0,192,96,0.4)` }}>
        <div className="container d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <img src="/logo-white.png" alt="RNP" style={{ width: '46px', height: 'auto' }} />
            <div>
              <div className="fw-bold text-white" style={{ fontSize: '16px' }}>Reaktor Nature Power</div>
              <div style={{ fontSize: '11px', color: G }}>Injection de gains</div>
            </div>
          </div>
          <button onClick={() => navigate('/dashboard')} className="btn btn-sm"
            style={{ background: 'rgba(0,192,96,0.2)', border: `1px solid rgba(0,192,96,0.5)`, color: '#fff' }}>
            <i className="fas fa-arrow-left me-2"></i>Dashboard
          </button>
        </div>
      </nav>

      <div className="container py-4" style={{ maxWidth: '620px' }}>
        {message.text && (
          <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'} alert-dismissible fade show mb-3`} role="alert">
            <i className={`fas fa-${message.type === 'success' ? 'check-circle' : 'exclamation-circle'} me-2`}></i>
            {message.text}
            <button type="button" className="btn-close btn-close-white" onClick={() => setMessage({ type: '', text: '' })}></button>
          </div>
        )}

        <div className="mb-4">
          <h2 className="fw-bold mb-1" style={{ color: '#1a3322', fontSize: '26px' }}>
            <i className="fas fa-syringe me-2" style={{ color: G }}></i>Injection de gains
          </h2>
          <p style={{ color: 'rgba(0,0,0,0.5)', margin: 0 }}>Forcer un gain pour le prochain joueur</p>
        </div>

        <div style={{ background: CARD, borderRadius: '16px', border: `1px solid ${BORDER}`, boxShadow: SHADOW, padding: '28px' }}>
          <div style={{ padding: '14px 16px', background: 'rgba(245,124,0,0.12)', border: '1px solid rgba(245,124,0,0.4)', borderRadius: '10px', marginBottom: '24px' }}>
            <p style={{ color: '#ffaa44', margin: 0, fontSize: '13px', fontWeight: 600 }}>
              <i className="fas fa-exclamation-triangle me-2"></i>
              Le prochain participant qui joue sur la session sélectionnée recevra ce lot garanti.
            </p>
          </div>

          <div className="mb-4">
            <label style={{ color: '#1a3322', fontWeight: 700, fontSize: '13px', display: 'block', marginBottom: '8px' }}>
              <i className="fas fa-calendar-alt me-2" style={{ color: G }}></i>Session *
            </label>
            <select value={selectedSession} onChange={e => setSelectedSession(e.target.value)} style={selectStyle}>
              <option value="">Sélectionner une session</option>
              {sessions.map(s => (
                <option key={s.id} value={s.id}>{s.name} — {s.pdv_name}</option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <label style={{ color: '#1a3322', fontWeight: 700, fontSize: '13px', display: 'block', marginBottom: '8px' }}>
              <i className="fas fa-gift me-2" style={{ color: G }}></i>Lot à forcer *
            </label>
            <select value={selectedPrize} onChange={e => setSelectedPrize(e.target.value)} style={selectStyle}>
              <option value="">Sélectionner un lot</option>
              {prizes.filter(p => !p.prize_type?.includes('try_again') && !p.prize_type?.includes('reessayer')).map(p => (
                <option key={p.id} value={p.prize_type}>{p.prize_label || p.name}</option>
              ))}
            </select>
          </div>

          <button onClick={handleInject} disabled={loading || !selectedSession || !selectedPrize}
            className="btn w-100 fw-bold" style={{
              background: loading || !selectedSession || !selectedPrize
                ? 'rgba(0,192,96,0.3)'
                : `linear-gradient(135deg, ${G}, ${G_DARK})`,
              color: '#1a3322', border: 'none', padding: '14px', borderRadius: '12px',
              fontSize: '16px', cursor: loading ? 'wait' : 'pointer',
              boxShadow: (!loading && selectedSession && selectedPrize) ? '0 6px 20px rgba(0,192,96,0.35)' : 'none'
            }}>
            {loading
              ? <><span className="spinner-border spinner-border-sm me-2"></span>Injection en cours...</>
              : <><i className="fas fa-syringe me-2"></i>Injecter ce gain</>
            }
          </button>
        </div>
      </div>
    </div>
  );
};

export default Injection;
